import { motion } from "framer-motion";
import { MessageCircle, ArrowUpRight, Recycle } from "lucide-react";
import { waLink, WA_DISPLAY } from "../lib/api";

export default function CTABanner() {
    return (
        <section className="py-16 md:py-24">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="relative overflow-hidden rounded-[36px] border-2 border-brand-ink bg-brand-tomato text-brand-cream p-10 md:p-16 shadow-hard"
                >
                    <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-brand-sunshine border-2 border-brand-ink rotate-12" aria-hidden="true" />
                    <div className="absolute -bottom-20 -left-10 w-56 h-56 rounded-full bg-brand-carrot border-2 border-brand-ink" aria-hidden="true" />

                    <div className="relative max-w-2xl">
                        <p className="font-hand text-3xl text-brand-sunshine rotate-[-2deg] inline-flex items-center gap-2">
                            <Recycle className="w-7 h-7 text-brand-sunshine" strokeWidth={2.4} />
                            kamu produsen kerajinan kertas?
                        </p>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
                            Daftar Jadi Kreator via WhatsApp
                        </h2>
                        <p className="mt-4 text-brand-cream/85 text-base sm:text-lg leading-relaxed">
                            Kamu yang bikin, kami yang input-in produknya biar sesuai standar toko. Cukup kirim foto
                            dan detail karyamu ke WhatsApp Customer Service kami di {WA_DISPLAY}.
                        </p>
                        <div className="mt-8 flex flex-wrap gap-3.5">
                            <a
                                data-testid="wa-consultation-banner-button"
                                href={waLink("Halo Acture.id! Saya produsen kerajinan kertas, mau daftar jadi kreator.")}
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center gap-2 px-7 py-4 rounded-full border-2 border-brand-ink bg-brand-wa text-white font-display font-bold shadow-hard-sm hover:-translate-y-0.5 hover:shadow-hard transition-all active:translate-y-0 active:shadow-hard-sm"
                            >
                                <MessageCircle className="w-5 h-5" strokeWidth={2.4} /> Daftar via WhatsApp
                            </a>
                            <a
                                href="#katalog"
                                onClick={(e) => { e.preventDefault(); document.getElementById("katalog")?.scrollIntoView({ behavior: "smooth" }); }}
                                className="inline-flex items-center gap-2 px-7 py-4 rounded-full border-2 border-brand-ink bg-brand-cream text-brand-ink font-display font-bold shadow-hard-sm hover:-translate-y-0.5 hover:shadow-hard transition-all active:translate-y-0 active:shadow-hard-sm"
                            >
                                Lihat Dulu Katalognya <ArrowUpRight className="w-5 h-5" strokeWidth={2.6} />
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
